import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 14.5C13.1046 14.5 14 13.6046 14 12.5C14 11.3954 13.1046 10.5 12 10.5C10.8954 10.5 10 11.3954 10 12.5C10 13.6046 10.8954 14.5 12 14.5Z",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 8.5L13.414 11.086",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 12.4999C21.0002 13.9285 20.6589 15.3364 20.0045 16.6063C19.3501 17.8761 18.4015 18.9711 17.238 19.7999C16.5722 20.2645 15.7778 20.5092 14.966 20.4999H9.026C8.23237 20.5114 7.45469 20.2767 6.8 19.8279C5.21895 18.7129 4.0399 17.1175 3.43808 15.2788C2.83626 13.4401 2.8438 11.4562 3.45958 9.62215C4.07535 7.78808 5.2665 6.20164 6.85597 5.09865C8.44545 3.99565 10.3484 3.43497 12.282 3.49994C14.6115 3.5977 16.8145 4.58583 18.4367 6.26049C20.0589 7.93514 20.9764 10.1686 21 12.4999Z",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDashboard);
export default ForwardRef;
